module.exports = __webpack_public_path__ + "img/stock3.1b21d261.png";